import { useCallback, useEffect, useMemo, useState } from 'react';

export const useApi = (apiFunc, config) => {
  const [isLoading, setIsLoading] = useState(false);

  const triggerFetchDefaultOption = useMemo(
    () => ({
      returnOnly: false,
      args: config?.args,
      enabled: true,
      signal: null,
    }),
    [config]
  );

  const triggerFetch = useCallback(
    async (option = triggerFetchDefaultOption) => {
      const options = { ...triggerFetchDefaultOption, ...option };
      if (options.enabled === false) return;
      setIsLoading(true);
      let response;
      try {
        if (Array.isArray(options?.args)) {
          response = await apiFunc(...options?.args, options.signal);
        } else {
          response = await apiFunc(options?.args, options.signal);
        }
        if (options.returnOnly) {
          setIsLoading(false);
          return response;
        }
        if (response?.status) {
          config?.onSuccess?.(response);
        } else {
          config?.onError?.(response);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          config?.onError?.(error);
        }
      } finally {
        setIsLoading(false);
      }
      return response;
    },
    [apiFunc, config, triggerFetchDefaultOption]
  );

  useEffect(() => {
    if (config?.type === 'mutation' || config.enabled === false) return;
    triggerFetch();
  }, []);

  return {
    triggerFetch,
    isLoading,
    setIsLoading,
  };
};
